export enum BORDER_ACTIVE {
  LEFT = 'left',
  RIGHT = 'right',
  BOTH = 'both',
}

export const MIN_ROW_HEIGHT = 162